import React from 'react';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { SubmitButton } from '../form/submit_button';

class ConverterSuccess extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.fileDownload();
  }

  fileDownload() {
    this.downloadConvertedFile(`${this.props.cdnPath}/${this.props.cdnDownloadPath}`);
  }

  getFileDownload() {
    return () => {
      this.fileDownload();
    };
  }

  handleSaveAsMap() {
    return () => {
      const slug = this.props.convertedSlug;
      const slugPart = slug.split('/').pop();
      const context = this;
      const formData = new FormData();
      formData.append('slug', slugPart);
      this.claimMap(formData)
        .then(response => {
          window.location = context.props.convertedSlug;
        })
        .catch(function(err) {
          context.handleError(context.strings.ERROR_MESSAGES.UPLOAD_FAILED);
        });
    };
  }

  handleError(message) {
    this.setState({
      submitting: false,
      errorMessage: message
    });
  }

  claimMap(data) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      // todo: parameterize this path
      xhr.open('POST', '/api/alltrails/convert/claim', true);
      xhr.setRequestHeader('X-AT-KEY', this.props.apiKey);
      xhr.setRequestHeader('X-AT-AUTH-TOKEN', this.props.authToken);
      xhr.setRequestHeader('X-CSRF-Token', document.querySelector('meta[name="csrf-token"]').content);
      xhr.onload = function() {
        if (this.status >= 200 && this.status < 300) {
          resolve(xhr.response);
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText
          });
        }
      };
      xhr.onerror = function() {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      };
      xhr.send(data);
    });
  }

  getMapTypeDisplay(type) {
    if (!type) {
      return;
    }
    return this.isTypeRecording(type)
      ? StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.RECORDINGS
      : StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.MAPS;
  }

  downloadConvertedFile(filePath) {
    fetch(filePath).then(response => {
      const downloadName = response.url.split('/').slice(-1)[0];
      response.blob().then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = downloadName;
        // some browsers (at least Firefox) require that this element is added to the DOM before triggering a click event on it
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    });
  }

  isTypeRecording(type) {
    const trackTypesArray = ['t', 'track'];
    return trackTypesArray.indexOf(type.toLowerCase()) > -1;
  }

  renderFoot() {
    return (
      <div className="success-foot">
        {this.props.mapType ? this.renderSaveMapButton() : ''}
        <div className="foot-group">
          <div className="subtitle2">{StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.SUBTITLE_CREATE_MAP}</div>
          <div className="button-wrapper">
            <a href={this.props.createMapPath} className="button outline">
              {StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.BUTTON_CREATE_MAP}
            </a>
          </div>
        </div>
      </div>
    );
  }

  renderSaveMapButton() {
    return (
      <div className="foot-group">
        <div className="subtitle2">{StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.SUBTITLE_SAVE}</div>
        <div className="button-wrapper">
          <SubmitButton
            text={`${StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.BUTTON_SAVE} ${this.getMapTypeDisplay(this.props.mapType)}`}
            onClick={this.handleSaveAsMap().bind(this)}
            className="button outline"
            submitting={this.props.submitting}
            submittingText={StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.SUBMITTING_TEXT}
          />
          <div className="errorMessage">{this.props.errorMessage}</div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="wrapper">
        <div className="head">
          <div className="hero converter-hero">
            <h1>{StringConstantsMixin.strings.CONVERTER.HERO_TITLE}</h1>
          </div>
        </div>
        <div className="container">
          <div className="success-wrapper">
            <div className="icon-holder">
              <img className="success-img" src="https://cdn-assets.alltrails.com/assets/icons/green-check-outline.png" />
            </div>
            <h5>{StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.TITLE}</h5>
            <div className="body1">
              {StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.PROMPT_LEAD}{' '}
              <a onClick={this.getFileDownload().bind(this)}>{StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.HERE}</a>{' '}
              {StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.PROMPT_TAIL}
            </div>
            <div className="body1">
              {StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.CONVERT_ANOTHER_FILE}{' '}
              <a href="/converter">{StringConstantsMixin.strings.CONVERTER.CONVERTER_SUCCESS.HERE}</a>
            </div>
            {!this.props.mobileBrowser ? this.renderFoot() : ''}
          </div>
        </div>
      </div>
    );
  }
}

export { ConverterSuccess };
